import BrowserTokenActionTypes from './types'
import BrowserTokenService from '../../../services/browserToken'

export const BrowserTokenActionCreators = {
  setBrowserToken: browserToken => ({
    type: BrowserTokenActionTypes.SET_BROWSER_TOKEN,
    payload: browserToken,
  }),

  setBrowserTokenError: payload => ({
    type: BrowserTokenActionTypes.SET_BROWSER_TOKEN_ERROR,
    payload,
  }),

  getBrowserToken: data => async dispatch => {
    try {
      // dispatch(LoadingActionCreators.loadingState(true))

      const res = await BrowserTokenService.getBrowserToken(data)

      dispatch(
        BrowserTokenActionCreators.setBrowserToken(res.data.browserToken),
      )
      dispatch(BrowserTokenActionCreators.setBrowserTokenError(''))

      return res
    } catch (e) {
      dispatch(BrowserTokenActionCreators.setBrowserTokenError(e))
    } finally {
      // dispatch(LoadingActionCreators.loadingState(false))
    }
  },
}
